import axios from "axios"

const url = "/distributor/admin/api/v1/inventory/loose-items"
export function getAllLooseItemListing (parameters) {
  return new Promise((resolve, reject) => {
    axios.post(url, {
      length: parameters.length,
      start: parameters.start,
      order: parameters.order,
      order_by: parameters.order_by,
      dealer: parameters.dealer,
      filter: {
        nodes: parameters.filter.nodes,
        search: parameters.filter.search,
      }
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};